
import { removeCompanySession, getCompanySession, getProjectSession, removeProjectSession } from "../../../../app/component/helper";
import { toAbsoluteUrl, getFullUrl } from "../../../helpers";
import { companySession } from "../../../../app/master/api";
import { useAuth } from "../../../../app/modules/auth";

const CompanyTitle = () => {
    const { currentUser } = useAuth()

    const project = getProjectSession()
    const company = getCompanySession()

    const goToAdmin = async () => {
        try {
            const data = await companySession(0, 0)
            if (data?.code === 1) {
                removeCompanySession()
            } else {
                console.error('not logout')
            }
        } catch (error) {
            console.error(error?.response?.data?.message || 'Could not clear company session')
        }
    }
    const goToProject = async () => {
        try {
            const data = await companySession(0, 0)
            if (data?.code === 1) {
                removeProjectSession()
            } else {
                console.error('not logout')
            }
        } catch (error) {
            console.error(error?.response?.data?.message || 'Could not clear project session')
        }
    }
    if (!project && !company) {
        return false
    }
    return currentUser?.accesses?.role !== "Team" ? <>
        {

            <div style={{ background: '#fff9f9' }}
                className="app-toolbar border py-lg-3 py-3  mb-1" >
                <div className="app-container container-fluid d-flex flex-stack">
                    <div className="d-flex justify-content-between flex-lg-grow-1">
                        <div className="page-title d-flex flex-column justify-content-center me-3 flex-wrap">
                            <div className="d-flex align-items-center">

                                <div className="symbol me-5">
                                    {company &&
                                        <img alt="Logo" src={company?.small_logo ? getFullUrl(company?.small_logo) : toAbsoluteUrl('/media/logos/blank-big.jpg')} />
                                    }
                                    {project &&
                                        <img alt="Logo" src={project?.small_logo ? getFullUrl(project?.small_logo) : toAbsoluteUrl('/media/logos/blank-big.jpg')} />
                                    }
                                    {/* <img alt="Logo" src={toAbsoluteUrl('/media/logos/blank-big.jpg')} /> */}
                                </div>
                                <div className="d-flex flex-column">
                                    {company &&
                                        <h3 className="mb-1 text-danger">{company?.company_name}</h3>
                                    }
                                    {project &&
                                        <h3 className="mb-1 text-danger">{project?.project_name}</h3>
                                    }

                                    <div className="text-muted fw-bold">
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="me-3 flex-shrink-0">
                            {(currentUser?.accesses?.role !== "npp project") && <>
                                {company &&
                                    <button onClick={(e) => goToAdmin()} className="btn btn-danger btn-sm text-white fs-6">
                                        Go to Admin </button>
                                }
                                {project &&
                                    <button onClick={(e) => goToProject()} className=" btn btn-danger btn-sm text-white fs-6 ">
                                        Go to Admin </button>
                                }
                            </>
                            }


                        </div>

                    </div>
                </div>
            </div>

        }

    </> : null
}

export { CompanyTitle }
